import * as Sentry from "@sentry/nuxt";
import { defineNuxtPlugin } from "#app";
import { isIgnorableError } from "~/constants/ignorable-errors";

/**
 * Client-only plugin that listens for unhandled promise rejections and reports them to Sentry.
 * Kept separate to ensure `window` is only accessed in a browser context.
 */
export default defineNuxtPlugin(() => {
  globalThis.window.addEventListener("unhandledrejection", (event) => {
    // `beforeSend` already drops these from Sentry, but the console.error below
    // runs first and would keep the third-party noise in the browser console.
    if (isIgnorableError(event.reason)) {
      return;
    }

    console.error("Sentry handler - Failed promise:", event.reason);
    Sentry.captureException(event.reason);
  });
});
